import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4e83068c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4e83068c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e83068c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e83068c')) {
      api.createRecord('4e83068c', component.options)
    } else {
      api.reload('4e83068c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4e83068c&scoped=true", function () {
      api.rerender('4e83068c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/subSidebar/index.vue"
export default component.exports